'use strict';

/* eslint no-console: 0 */
define('lib/analytics/context.add',['./config', './combineBlocks'], function (config, combineBlocks) {
  return function contextAdd($el) {
    var args = Array.prototype.slice.call(arguments); // turn args into legit Arr
    var noFirst = args.slice(1); // new arr without $el;
    var blocks;
    var existingBlock = $el.data('anctx');
    var newBlock = combineBlocks(noFirst);

    if (existingBlock) {
      blocks = combineBlocks([existingBlock, newBlock]);
    } else {
      blocks = newBlock;
    }

    $el.data('anctx', blocks);

    if (config.debug && config.debug.contextAdd) {
      console.groupCollapsed('DL 1.5: Context Add');
      console.log(blocks);
      console.log('To Component:', $el);
      console.groupEnd();
    }
  };
});

